import React from 'react';

export type ModalParentNodeRef = HTMLElement;

export const ModalParentNodeContext = React.createContext<ModalParentNodeRef>(
  undefined as any,
);
export const ModalParentNodeRefProvider = ModalParentNodeContext.Provider;
export const ModalParentNodeRefConsumer = ModalParentNodeContext.Consumer;
